module.exports = __webpack_public_path__ + "img/counter.a58ebff0.gif";